export const spacing = {
    xs: '2px',
    sm: '5px',
    md: '10px',
    lg: '15px',
    xl: '20px',
};
